<template>
  <div class="my-setting-modal-cover" @click="onClose" v-if="!isLeaved">
    <div class="my-setting-container" @click.stop>
      <div class="my-setting-header-container">
        <button v-if="!isOpenDepsModal" class="close-modal" @click="onClose"></button>
        <button v-else class="back-feature" @click="onCloseDepsModal"></button>
        <div v-if="!isOpenDepsModal">{{ $t('camstudy.mySetting.title') }}</div>
        <div v-else>{{ modalTitle }}</div>
        <div class="my-setting-icon"></div>
      </div>
      <div v-if="!isOpenDepsModal" class="my-setting-body-container">
        <ul class="my-setting-inner-container">
          <li v-if="isOpenFixedScreen" class="my-setting-item">
            <div class="my-setting-item-content">
              <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.fixMyScreen') }}</p>
              <GrmToggle :is-checked.sync="fixedScreen" @onChange="changeStatus"/>
            </div>
            <div class="my-setting-item-description">{{ $t('camstudy.mySetting.fixMyScreenDesc') }}</div>
          </li>
          <li v-if="isOpenAutoBrightness" class="my-setting-item">
            <div class="my-setting-item-content">
              <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.autoBrightness') }}</p>
              <GrmToggle :is-checked.sync="autoBrightness" @onChange="changeStatus"/>
            </div>
            <div class="my-setting-item-description">{{ $t('camstudy.mySetting.autoBrightnessDesc') }}</div>
          </li>
          <!-- <li class="my-setting-item"
              v-show="$isBrowserAvailable('safari', 15.6)"
          >
            <div class="my-setting-item-content" @click="onOpenBlurModal">
              <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.videoBlur.title') }}</p>
              <img src="@/assets/images/camstudy/ico_arrowRight_gray.svg" />
            </div>
            <div class="my-setting-item-description">{{ $t('camstudy.mySetting.videoBlur.description') }}</div>
          </li> -->
          <li class="my-setting-item">
            <div class="my-setting-item-content">
              <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.autoBrightnessTimeSetting') }}</p>
              <div class="select-container">
                <GrmCamstudySelect :title="$t('camstudy.mySetting.timeSetting')" :value.sync="autoBrightnessTerm" :list="brightnessTimeOptions"
                                   name="bright-time" @onChange="changeStatus"/>
              </div>
            </div>
            <div class="my-setting-item-description">{{ $t('camstudy.mySetting.autoBrightnessTimeDesc') }}</div>
          </li>
          <li class="my-setting-item" @click="onOpenTestFeature">
            <div class="my-setting-item-content">
              <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.laboratory') }}</p>
              <img src="@/assets/images/camstudy/ico_arrowRight_gray.svg" />
            </div>
            <div class="my-setting-item-description">{{ $t('camstudy.mySetting.laboratoryDesc') }}</div>
          </li>
          <li class="my-setting-item" @click="onOpenLanguageModal">
            <div class="my-setting-item-content">
              <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.language.title') }}</p>
              <div>
                <img src="@/assets/images/camstudy/ico_arrowRight_gray.svg" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else-if="modalType === 'test-feature'" class="my-setting-body-container">
        <div class="test-feature-container">
          <img src="@/assets/images/camstudy/test_feature_image.svg" class="test-feature-image" />
          <div>
            <div class="test-feature-title">{{ $t('camstudy.mySetting.testFeatureTitle') }}</div>
            <div class="test-feature-message">{{ $t('camstudy.mySetting.testFeatureMessage') }}</div>
          </div>
        </div>
        <ul class="my-setting-inner-container">
<!--          <li class="my-setting-item">-->
<!--            <div class="my-setting-item-content">-->
<!--              <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.faceMask') }}</p>-->
<!--              <GrmToggle :is-checked.sync="coverFace" @onChange="onFaceMaskChangeHandler"/>-->
<!--            </div>-->
<!--            <div class="my-setting-item-description">{{ $t('camstudy.mySetting.faceMaskDesc') }}</div>-->
<!--          </li>-->
        </ul>
      </div>
      <div v-else-if="modalType === 'language-setting'" class="my-setting-body-container">
        <ul class="my-setting-inner-container">
          <li v-for="lang in sortedLanguages" :key="lang.value" class="my-setting-item">
            <label @click="onChangedOption">
              <div class="my-setting-item-content">
                <p class="my-setting-item-paragraph">{{ lang.name }}</p>
                <input type="radio" name="language-radio" :value="lang.value" :checked="selectedValue === lang.value" />
              </div>
            </label>
          </li>
        </ul>
      </div>
      <!-- <div v-else-if="modalType === 'video-blur'" class="my-setting-body-container">
        <ul class="my-setting-inner-container">
          <li class="my-setting-item">
            <div class="my-setting-item-content">
              <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.videoBlur.title') }}</p>
              <div class="select-container">
                <GrmToggle :is-checked.sync="blurVideo.use" @onChange="onChangeBlurOptions" />
              </div>
            </div>
            <div class="my-setting-item-description">{{ $t('camstudy.mySetting.videoBlur.description') }}</div>
          </li>
          <li class="my-setting-item" v-show="blurVideo.use">
            <div class="my-setting-item-content">
              <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.videoBlur.areaSize') }}</p>
              <div class="select-container">
                <GrmCamstudySelect :title="$t('camstudy.mySetting.videoBlur.areaSize')" :value.sync="blurVideo.percent" :list="blurPercentList"
                                   name="blur-size" @onChange="onChangeBlurOptions"/>
              </div>
            </div>
          </li>
          <li class="my-setting-item" v-show="blurVideo.use">
            <div class="my-setting-item-content">
              <p class="my-setting-item-paragraph">{{ $t('camstudy.mySetting.videoBlur.intensity') }}</p>
              <div class="select-container">
                <GrmCamstudySelect :disabled="blurVideo.percent <= 0" :title="$t('camstudy.mySetting.videoBlur.intensity')" :value.sync="blurVideo.blurSize" :list="blurSizeList"
                                   name="blur-intensity" @onChange="onChangeBlurOptions"/>
              </div>
            </div>
            <div class="my-setting-item-description">{{ $t('camstudy.mySetting.videoBlur.description') }}</div>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
import GrmToggle from "@/components/Common/toggle/GrmToggle.vue";
import GrmCamstudySelect from "@/components/Common/camstudySelect/GrmCamstudySelect.vue";
import {mapActions, mapGetters} from "vuex";
import {debounce} from "lodash";
import VideoPauseMixin from "@/components/Room/Camstudy/mixins/VideoPauseMixin.vue";

export default {
  name: "CamstudyMySettingModal",
  mixins: [VideoPauseMixin],
  components: {GrmCamstudySelect, GrmToggle},
  data(){
    return {
      autoBrightnessTerm: 60,
      fixedScreen: false,
      autoBrightness: false,
      coverFace: false,
      isOpenDepsModal: false,
      isOpenFixedScreen: false,
      isOpenAutoBrightness: false,
      blurVideo: {
        use: false,
        percent: 0.5,
        blurSize: 5,
      },
      modalType: '',
      selectedValue: this.$i18n.locale,
      isFaceMaskEnabled: true,
    }
  },
  watch: {
    autoBrightnessTerm(newVal) {
      this.autoBrightnessTerm = Number(newVal)
    },
    // guild : 데이터 변경 감지 :: 필수 - ...mapGetters['camstudy', 'personalSetting']
    // 'personalSetting.autoBrightnessTerm' : {
    //   handler(oldVal, newVal) {
    //     console.log('######### personalSetting.autoBrightnessTerm : ' + oldVal + ', ' + newVal);
    //   },
    //   deep: true,
    // },
  },
  computed: {
    ...mapGetters('room', [
      'isLeaved',
    ]),
    ...mapGetters('camstudy', ['personalSetting', 'isUserTrialEnabledBy']),
    brightnessTimeOptions() {
      return [
        {name: this.$t('camstudy.mySetting.brightnessTimes.1min'), value: 60},
        {name: this.$t('camstudy.mySetting.brightnessTimes.2min'), value: 120},
        {name: this.$t('camstudy.mySetting.brightnessTimes.3min'), value: 180},
        {name: this.$t('camstudy.mySetting.brightnessTimes.4min'), value: 240},
        {name: this.$t('camstudy.mySetting.brightnessTimes.5min'), value: 300},
        {name: this.$t('camstudy.mySetting.brightnessTimes.10min'), value: 600}
      ];
    },
    blurPercentList() {
      return [50,70,80,90,100].map(n => ({name:`${n}%`, value:n/100}))
    },
    blurSizeList() {
      return [
        {name: this.$t('camstudy.mySetting.videoBlur.level.light'), value: 5},
        {name: this.$t('camstudy.mySetting.videoBlur.level.normal'), value: 10},
        {name: this.$t('camstudy.mySetting.videoBlur.level.strong'), value: 15},
      ]
    },
    modalTitle(){
      if(this.modalType === 'language-setting'){
        return this.$t('camstudy.mySetting.language.title')
      }else if(this.modalType === 'video-blur'){
        return this.$t('camstudy.mySetting.videoBlur.title')
      }else{
        return this.$t('camstudy.mySetting.laboratory')
      }
    },
    sortedLanguages() {
      const languages = [
        { name: '한국어', value: 'ko' },
        { name: 'English', value: 'en' }
      ];
      return languages
    },
  },
  async created() {
    this.init();
  },
  methods: {
    ...mapActions('camstudy', ['modifyPersonalSetting', 'getVideoBlurOptions', 'changeVideoBlur']),
    init() {
      const setting = this.personalSetting;
      this.autoBrightnessTerm = setting.autoBrightnessTerm;
      this.fixedScreen = this.statusToBoolean(setting.fixedScreen);

      this.isFaceMaskEnabled = this.isUserTrialEnabledBy('FACE_MASK')
      if (!this.isFaceMaskEnabled) {
        this.coverFace = false
      } else {
        this.coverFace = this.statusToBoolean(setting.coverFace);
      }

      this.initBlurOptions()
    },
    statusToBoolean(status) {
      return status === 'on';
    },
    booleanToStatus(boolean) {
      return boolean ? 'on' : 'off';
    },
    onFaceMaskChangeHandler() {
      if (!this.isFaceMaskEnabled) {
        this.$camsAlert({
          text: this.$t('FREE 등급 방에서는 사용할 수 없는 기능입니다.'),
          onlyOk: true
        });
        this.coverFace = false
      }

      this.changeStatus()
    },
    changeStatus: debounce(async function() {
      await this.modifyPersonalSetting({
        autoBrightnessTerm: this.autoBrightnessTerm,
        fixedScreen: this.booleanToStatus(this.fixedScreen),
        coverFace: this.booleanToStatus(this.coverFace),
        // blurVideo: {...this.blurVideo}
      });
    }, 100),
    onChangeBlurOptions() {
      if (!this.blurVideo.use) {
        this.resetBlurOptions()
      }
      this.changeVideoBlur({... this.blurVideo })
    },
    onClose(){
      this.$modal('CamstudyMySettingModal', {once: true})
    },
    onCloseDepsModal(){
      this.isOpenDepsModal = false;
      this.modalType = '';
    },
    onOpenTestFeature(){
      this.isOpenDepsModal = true;
      this.modalType = 'test-feature'
    },
    onOpenLanguageModal(){
      this.isOpenDepsModal = true;
      this.modalType = 'language-setting'
    },
    onOpenBlurModal(){
      this.isOpenDepsModal = true;
      this.modalType = 'video-blur'
    },
    async initBlurOptions() {
      // const personalSetting = localStorage.getItem('grm_cams_personal_video_setting')
      const blurVideo = await this.getVideoBlurOptions();
      if (blurVideo) {
        this.blurVideo.use = blurVideo.use || false
        this.blurVideo.percent = blurVideo.percent || 0.5
        this.blurVideo.blurSize = blurVideo.blurSize
      }
    },
    resetBlurOptions() {
      this.blurVideo.percent = 0;
      this.blurVideo.blurSize = 5;
    },
    onChangedOption(e) {
      if (!e.target.value) {
        return;
      }
      this.selectedValue = this.$i18n.setLocale(e.target.value);
    }
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile] {
  .my-setting-modal-cover {
    background-color: rgba(0, 0, 0, 0.5);
    @media(orientation: portrait) {
      left: 0;
      right: 0;
      bottom: 64px;
    }
    @media(orientation: landscape) {
      left: env(safe-area-inset-left);
      right: env(safe-area-inset-right);
      bottom: 98px;
      z-index: 99;
    }
    .my-setting-container {
      @media(orientation: portrait) {
        bottom: 0;
        left: 0;
        width: 100%;
        .my-setting-body-container {
          height: calc(100dvh - 107px);
        }
      }
      @media(orientation: landscape) {
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        .my-setting-body-container {
          height: calc(100% - 44px);
        }
      }
    }
  }
}
html:not([grm-device-mobile]) {
  .my-setting-modal-cover {
    left: 0;
    right: 0;
    bottom: 80px;
    top: 0;
    .my-setting-container{
      bottom: -80px;
      top: 0;
      right: 0;
      width: 360px;

      .my-setting-body-container {
        height: calc(100% - 44px);
      }
      border-left: 0.5px solid rgba(255, 255, 255, 0.20);
      background: #1A1A1A;
    }
  }
}
.my-setting-modal-cover{
  position: fixed;
  top: 0;
  z-index: 100;
}
.my-setting-container {
  position: absolute;
  line-height: 1.5;
  .my-setting-body-container{
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  background: #1F1F1F;
  color: white;
  z-index: 100;

  .test-feature-container{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 18px;
    flex-direction: column;
    height: 220px;
    text-align: center;

    .test-feature-image{
      width: 100px;
      height: 100px;
      flex-shrink: 0;
      aspect-ratio: 1/1;
    }
    .test-feature-title{
      color: #FFF;
      font-size: 14px;
      margin-bottom: 6px;
      line-height: 1.5;
    }
    .test-feature-message{
      color: #999;
      font-size: 11px;
      line-height: 1.5;
    }
  }

  .my-setting-header-container {
    display: flex;
    padding: 6px 16px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }
  .close-modal {
     width: 32px;
     height: 32px;
     background: url("~@/assets/images/camstudy/ico_close_white.svg") center no-repeat;
    background-size: auto 24px;
  }
  .back-feature{
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_arrowLeft_white.svg") center no-repeat;
    background-size: auto 24px;
  }

  .my-setting-icon {
    width: 32px;
    height: 32px;
  }

  .my-setting-item + .my-setting-item{
    border-top: 0.333px solid rgba(255,255,255,0.06);
  }
  .my-setting-item{
    padding: 12px 20px;

    .my-setting-item-content{
      display: flex;
      height: 32px;
      justify-content: space-between;
      align-items: center;

      .my-setting-item-paragraph{
        color: white;
        font-size: 14px;
      }
      .arrow-rotate{
        transform: rotate(180deg);
      }
    }
    .select-container{
      border-radius: 6px;
      overflow: hidden;
    }
    .my-setting-item-description{
      color: #999;
      font-size: 11px;
      line-height: 100%;
      padding-bottom: 8px;
    }
  }

  &:last-child {
    border: none;
  }
}

input[type=radio]{
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 22px;
  height: 22px;
  background: url('~@/assets/images/camstudy/ico_option_radio_not_checked.svg') no-repeat center;

  &:checked{
    background: url('~@/assets/images/camstudy/ico_option_radio_checked.svg') no-repeat center;
  }
}
.my-setting-inner-container{
  padding-bottom: 12px;
}
</style>